import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import selectors from 'selectors'
import locationActions from 'actions/locations'
import locationGroupActions from 'actions/locationGroups'
import userGroupActions from 'actions/userGroups'
import userActions from 'actions/users'
import Component from 'components/CycleCounts/Filter'

const mapStateToProps = (state, props) => ({
  ...createAuthStateToProps(state, props),
  locationGroups: selectors.locationGroups.selectOptions(state),
  locations: selectors.locations.selectOptions(state),
  userGroups: selectors.userGroups.selectOptions(state),
  users: selectors.users.selectOptions(state),
})

const mapDispatchToProps = (dispatch, props) => ({
  getLocationGroups: (params) => dispatch(locationGroupActions.getOptions(params)),
  getLocations: (params) =>
    dispatch(locationActions.getOptions({ locationVendingTypes: ['NonVending'], active: 'All', ...params })),
  getUserGroups: (params) => dispatch(userGroupActions.getOptions(params)),
  getUsers: (params) => dispatch(userActions.getOptions({ ...params, active: 'All' })),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
